export class Search {
	search_timeout: any;
	addresses: { text: string; id; string }[] = [];
	address_search_failed: boolean = false;
	searching: boolean = false;
}
